import React from "react";
import ModernPagination from "./ui/ModernPagination";

type Function = (page: number) => void;

interface PageProps {
  count: number;
  data: any;
  page: number;
  limit: number;
  loading: boolean;
  onPageChange: Function;
}

export default ({
  count,
  data,
  page,
  limit,
  loading,
  onPageChange,
}: PageProps) => {
  return (
    <ModernPagination
      count={count}
      data={data}
      page={page}
      limit={limit}
      loading={loading}
      onPageChange={onPageChange}
    />
  );
};